import * as ACTION_TYPES from './actiontypes';

// init
export const initRequest = () => ({
  type: ACTION_TYPES.INIT_REQUEST
});

export const initSuccess = result => ({
  type: ACTION_TYPES.INIT_SUCCESS,
  payload: {
    ...result
  }
});

export const initFailure = error => ({
  type: ACTION_TYPES.INIT_FAILURE,
  error
});

export const hydrateEncounterAuditReasons = encounterAuditReasons => ({
  type: ACTION_TYPES.HYDRATE_ENCOUNTER_AUDIT_REASONS,
  payload: {
    encounterAuditReasons
  }
});
